import React, { useEffect, useState }  from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../core/AuthContext';
import { getProfile } from "../core/store/actions/auth";
import { useDispatch, useSelector } from 'react-redux';
import { hasPlatformAccess, isFormerMember } from '../core/utils/permissionUtils';
import { ROUTE_PATHS } from '../core/routes';

/* This component is used to verify if the user is authenticated and redirect it to the login
  page in case it is not */

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, loading } = useAuth();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const [lastFetchTime, setLastFetchTime] = useState(null);
  const fetchInterval = 20 * 1000; // 20sec interval

  // Check if there's a token in localStorage
  const hasToken = localStorage.getItem('token');

  // Retrieve the user profile if authenticated but the profile data was for some reason not fetched
  useEffect(() => {
    if (!isAuthenticated || loading || user?.profile?._id) {
      return;
    }

    const currentTime = Date.now();
    if (lastFetchTime && currentTime - lastFetchTime <= fetchInterval) {
      return;
    }

    dispatch(getProfile());
    setLastFetchTime(currentTime);
  }, [isAuthenticated, loading, user?.profile?._id, lastFetchTime, dispatch, fetchInterval]);

  return (
    <Route
      {...rest}
      render={(props) => {
        // If there's no token at all, redirect immediately without showing loading
        if (!hasToken) {
          return <Redirect to="/" />;
        }

        if (loading) {
          return <div>Loading...</div>; // TODO: Replace with a spinner if needed
        }

        if (!isAuthenticated) {
          // If user is not authenticated, redirect to the home page
          return <Redirect to="/" />;
        }

        if (isFormerMember(user?.profile)) {
          return <Redirect to={ROUTE_PATHS.platformAccessRevoked} />;
        }

        if (!hasPlatformAccess(user?.profile)) {
          return <Redirect to={ROUTE_PATHS.waitingForHr} />;
        }

        // If authenticated and has platform access, render the component
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
